import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { Button, Typography } from "@mui/material";
import { PageContainer } from "../../../shared/PageContainer"
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import Stack from "@mui/material/Stack";
import { OtherSamplesFeedbackPageInfo } from "./OtherSamplesFeedbackPageInfo";

export const OtherSamplesFeedbackPage = () => {

  const { showSuccess, showError, showWarning, showInfo } = useFeedback();

  const buttonWidth = '100px';

  return (
    <PageContainer
      heading='Other Samples - Feedback'
      icon={<MiscellaneousServicesIcon />}
      pageInfo={<OtherSamplesFeedbackPageInfo />}
      wrapRightElementForMobile={false}
    >
      <PageDefaultSegment>
        <Typography>
          Use the feedback to show information to the user.<br />
          Click the buttons below to show differnt types of feedback.
        </Typography>
        <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="success"
            sx={{ width: buttonWidth }}
            onClick={() => showSuccess("Some success message")}
          >
            Success
          </Button>

          <Button
            variant="contained"
            data-testid="error"
            sx={{ width: buttonWidth }}
            color='error'
            onClick={() => showError("Some error message")}
          >
            Error
          </Button>

          <Button
            variant="contained"
            data-testid="warning"
            sx={{ width: buttonWidth }}
            color='warning'
            onClick={() => showWarning("Some warning message")}
          >
            Warning
          </Button>

          <Button
            variant="contained"
            data-testid="info"
            sx={{ width: buttonWidth }}
            color='info'
            onClick={() => showInfo("Some information message")}
          >
            Info
          </Button>

        </Stack>
        <Typography sx={{ marginTop: 2 }}>
          By default the feedback shows for a duration of 6 seconds.<br />
          You can make it shorter or longer by making use of the second parameter
        </Typography>
        <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="10seconds"
            onClick={() => showSuccess("Some success message for 10 seconds", 10000)}
          >
            10 second feedback
          </Button>

          <Button
            variant="contained"
            data-testid="2seconds"
            onClick={() => showSuccess("Some success message for 2 seconds", 2000)}
          >
            2 second feeback
          </Button>

        </Stack>
        <Typography sx={{ marginTop: 2 }}>
          You can also use html styling for the text.
        </Typography>
        <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="htmltest"
            onClick={() => showSuccess(
              <>Success message.<br />This is using <span style={{ color: 'turquoise', fontWeight: 'bold' }}>html</span>.</>
            )}
          >
            Using html
          </Button>

        </Stack>
      </PageDefaultSegment>
    </PageContainer>
  )
}
